/* eslint no-param-reassign: "off" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Municipality from '../../types/Municipality';

interface State {
  ids: number[];
  values: Record<number, Municipality>;
}

const initialState: State = {
  ids: [],
  values: {},
};

const municipalitiesSlice = createSlice({
  name: 'municipalities',
  initialState,
  reducers: {
    addMunicipality: (state, action: PayloadAction<Municipality>) => {
      const { id } = action.payload;
      state.ids.push(id);
      state.values[id] = action.payload;
    },

    updateMunicipality: (state, action: PayloadAction<Municipality>) => {
      const { id } = action.payload;
      state.values[id] = action.payload;
    },

    deleteMunicipality: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      state.ids.splice(state.ids.indexOf(id), 1);
      delete state.values[id];
    },

    setAllMunicipalities: (state, action: PayloadAction<Municipality[]>) => {
      state.ids = [];
      state.values = {};

      action.payload.forEach((value) => {
        const { id } = value;
        state.ids.push(id);
        state.values[id] = value;
      });
    },
  },
});

export const selectMunicipalities = (
  state: any,
): Record<number, Municipality> => state.municipalities.values;

export const {
  setAllMunicipalities,
  addMunicipality,
  updateMunicipality,
  deleteMunicipality,
} = municipalitiesSlice.actions;
export default municipalitiesSlice.reducer;
